namespace $ {
	export let $mol_action = $mol_wire_method
}
